export default __webpack_public_path__ + "static/media/opensans-200.3d5923f9.ttf";